import { StandardEvents } from '@shopify/events';

class SolsticeProductMessages extends HTMLElement {
  #section;
  #revision = 0;
  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#update);
  }
  disconnectedCallback() {
    this.#revision++;
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#update);
  }
  #update = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card, solstice-product-card')) return;
    const revision = ++this.#revision;
    event.promise.then(({ detail }) => {
      if (!this.isConnected || revision !== this.#revision || !detail?.html) return;
      if (!detail.newProduct && detail.productId && String(detail.productId) !== this.dataset.productId) return;
      const next = [...detail.html.querySelectorAll('solstice-product-messages')]
        .find((node) => node.dataset.blockId === this.dataset.blockId);
      if (!next) return;
      this.dataset.productId = next.dataset.productId;
      this.replaceChildren(...[...next.childNodes].map((node) => node.cloneNode(true)));
    }).catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[product-messages]', error);
    });
  };
}
if (!customElements.get('solstice-product-messages')) {
  customElements.define('solstice-product-messages', SolsticeProductMessages);
}
